<template>
  <div class="container" style="background-color: #fff;">
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div style="position: relative; width: 100%;">
      <div class="content">
        <!-- 标题 -->
        <div class="title-ty">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>机制币送评</span>服务内容</div>
        </div>
        <div class="fuwu-top-1" style="font-size: 28px; border: 1px solid #DDAF58; border-radius: 0; margin: 50px 0;">水石评级的机制币评级种类，包括银元、纪念币、金银币、铜元、镍币、外币等机制币。</div>
        <!-- 服务 -->
        <div style="padding: 0 50px 80px;">
          <div class="fuwu-title-ty" style="letter-spacing: 2px; margin-bottom: 50px;">评级服务</div>
          <div style="position: relative; padding: 20px 50px 30px 150px;">
            <img class="fuwu-top-img" style="width: 220px; height: 220px; left: -10px; top: -20px;" src="@/assets/image/fuwuneirong-yinyuan.png" alt="">   
            <img class="fuwu-top-img" style="width: 220px; height: 220px; left: 880px; top: 80px;" src="@/assets/image/jizhi-zengzhi-4.png" alt="">  
            <div class="fuwu-top-content" style=" border: none; height: auto; line-height: 35px;  border: 1px solid #DDAF58; padding: 30px 100px;">水石评级对送评机制币，进行真伪鉴定、评级打分、价值评估等评级服务，所有评级钱币信息官网存档，有据可查。</div>
          </div>  
          <!-- 服务时效 -->
          <div class="shixiao-box">
            <div class="shixiao-title">评级时效：</div>
            <div class="shixiao-list">
              <div class="shixiao-item">
                <img src="@/assets/icon/p-ping.png" alt="">
                <div class="shixiao-item-content">
                  <div class="shixiao-item-content-top">普通评级</div>
                  <div class="shixiao-item-content-bottom">10—15个工作日</div>
                </div>
              </div>
              <div class="shixiao-item">
                <img src="@/assets/icon/k-ping.png" alt="">
                <div class="shixiao-item-content">
                  <div class="shixiao-item-content-top">快速评级</div>
                  <div class="shixiao-item-content-bottom">5个工作日，费用为普评费用的两倍</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 增值服务 -->
        <div class="fuwu-top-box" style="padding: 50px 0;">
          <div class="fuwu-title-ty" style="padding-left: 50px;">增值服务</div>
          <ul class="zengzhi-list">
            <li class="zengzhi-item">
              <img class="zengzhi-item-img" src="@/assets/image/jizhi-zengzhi-1.jpg" alt="">
              <div class="zengzhi-item-content">
                <div class="zengzhi-item-title">重新评级</div>
                <div class="zengzhi-item-text">指钱币已由水石评级完成评级，送评人认为该币仍有提升分数空间，再次提交至水石评级进行的
                  复评服务。</div>
              </div>
            </li>
            <li class="zengzhi-item">
              <img class="zengzhi-item-img" src="@/assets/image/jizhi-zengzhi-2.jpg" alt="">
              <div class="zengzhi-item-content">
                <div class="zengzhi-item-title">换装评级</div>
                <div class="zengzhi-item-text">指钱币已由其他评级机构鉴定封装，送评人将其提交至水石评级进行重新鉴定评级，并更换为水
                  石评级专属封装盒。</div>
              </div>
            </li>
            <li class="zengzhi-item" style="border: none;">
              <img class="zengzhi-item-img" src="@/assets/image/jizhi-zengzhi-3.jpg" alt="">
              <div class="zengzhi-item-content">
                <div class="zengzhi-item-title">重新装盒</div>
                <div class="zengzhi-item-text">对外观出现磨损、损坏的水石评级封装盒进行更换。</div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 售后终身服务 -->
        <div class="fuwu-top-box" style="padding: 50px 0; border: none;">
          <div class="fuwu-title-ty" style="padding-left: 50px;">售后终身服务</div>
          <ul class="shouhou-list">
            <li class="shouhou-item" style="margin-bottom: 50px;">
              <div class="shouhou-item-tag">1</div>
              <img class="shouhou-item-img" style="width: 100px; height: 80px;" src="@/assets/icon/shouhou-1.png"
                alt="">
              <div>水石评级将对封装完好的机制币，根据其对应的档位，参考当下行情价格，做真伪终身售后服务。</div>
            </li>
            <li class="shouhou-item">
              <div class="shouhou-item-tag">2</div>
              <img class="shouhou-item-img" src="@/assets/icon/shouhou-2.png" alt="">
              <div>机制币售后时效，为5个工作日。</div>
            </li>
          </ul>
        </div>
      </div>
      <img src="@/assets/image/logo-shuiyin.png" alt=""
        style="width: 300px; position:absolute; bottom: 0px; left: 0px;" />
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  width: 1200px;
  margin: 0 auto;
}
</style>